import isTruthy from "@/lib/utils/boolean/isTruthy";
import { Player, RunWithStatusPlayers } from "@shared/lib/database/query.types";
import { parseISO } from "date-fns";
import { computed, Ref } from "vue";

export default function (run: Ref<RunWithStatusPlayers | null>) {
  const inPlayers = computed(() => getPlayersByStatus(statusPlayers.value, 1));
  const maybePlayers = computed(() => getPlayersByStatus(statusPlayers.value, 0.5));
  const outPlayers = computed(() => getPlayersByStatus(statusPlayers.value, 0));

  const statusPlayers = computed(() => {
    return [...run.value?.statuses || []]
      .sort(sortByCreated)
      .map((status) => status.player)
      .filter(isTruthy);
  });

  function getPlayersByStatus (players: Array<Player>, probability: number) {
    const playerIds = players.map((player) => player.id);

    return run.value?.statuses
      .filter((status) => status.probability === probability && playerIds.includes(status.player_id))
      .sort(sortByCreated)
      .map((status) => status.player)
      .filter(isTruthy);
  }

  function sortByCreated (a: { created_at: string }, b: { created_at: string }) {
    return +parseISO(a.created_at) - +parseISO(b.created_at);
  }

  return {
    statusPlayers,
    inPlayers,
    maybePlayers,
    outPlayers,
  };
}
